import { render, staticRenderFns } from "./PesquisarEstudante.vue?vue&type=template&id=1aaa27f2&"
import script from "./PesquisarEstudante.vue?vue&type=script&lang=js&"
export * from "./PesquisarEstudante.vue?vue&type=script&lang=js&"
import style0 from "./PesquisarEstudante.vue?vue&type=style&index=0&id=1aaa27f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports